


































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
/** 数值输入添加后缀单位 */
@Component({})
export default class InputNumberCom extends Vue {
  @Prop() value: any;
  @Prop() precision: number; // 保留小数后几位（四舍五入）
  @Prop() addonAfter: string; // 后缀
  @Prop() placeholder: string;
  @Prop() disabled: boolean;
  innerValue: number = 0;

  @Watch('value')
  watchValue(v: any) {
    this.innerValue = v;
  }

  mounted() {
    this.innerValue = this.value;
  }
  formatter(value: any) {
    return `${value}`.replace(/[^\d.]/, '');
  }
  parser(value: any) {
    return value.replace(/[^\d.]/, '');
  }

  onChange(v: any) {
    this.$emit('input', v);
    this.$emit('change', v);
  }
}
